import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faCircleExclamation, faFileExcel, faSquareXmark, faUpload} from '@fortawesome/free-solid-svg-icons';
import {
    BulkUploadSupportedValuesComponent,
} from '../components/bulk-upload-supported-values/bulk-upload-supported-values.component';
import {
    BulkUploadSupportedField,
    BulkUploadSupportedValuesTip,
} from '../components/bulk-upload-supported-values/bulk-upload-supported-values.model';

export type BulkUploadShellMode = 'modal' | 'page' | 'inline';

/**
 * Presentation-only bulk upload shell.
 * Parents own upload API calls via BulkUploadFlow (or equivalent) and result handling.
 */
@Component({
    selector: 'app-bulk-upload-shell',
    imports: [CommonModule, FontAwesomeModule, BulkUploadSupportedValuesComponent],
    templateUrl: './bulk-upload-shell.component.html',
    styleUrl: './bulk-upload-shell.component.css',
})
export class BulkUploadShellComponent {
    @Input() mode: BulkUploadShellMode = 'modal';
    @Input() open = false;
    @Input() title = 'Bulk Upload';
    @Input() intro = '';
    @Input() accept = '.csv,.xlsx';
    @Input() uploading = false;
    @Input() disabled = false;
    @Input() selectedFile: File | null = null;
    @Input() showDownloadTemplate = true;
    @Input() showGuidelines = false;
    @Input() supportedFields: BulkUploadSupportedField[] = [];
    @Input() supportedTip?: BulkUploadSupportedValuesTip | string;
    @Input() supportedTitle = 'Supported Values';

    @Output() downloadTemplate = new EventEmitter<void>();
    @Output() guidelinesClick = new EventEmitter<void>();
    @Output() fileSelected = new EventEmitter<File>();
    @Output() submitUpload = new EventEmitter<File>();
    @Output() cancel = new EventEmitter<void>();

    constructor(library: FaIconLibrary) {
        library.addIcons(faUpload, faFileExcel, faSquareXmark, faCircleExclamation);
    }

    onFileInputChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        input.value = '';
        if (!file || this.disabled || this.uploading) {
            return;
        }
        this.fileSelected.emit(file);
        if (this.mode === 'inline' || this.mode === 'page') {
            this.submitUpload.emit(file);
        }
    }

    onSubmit(): void {
        if (!this.selectedFile || this.disabled || this.uploading) {
            return;
        }
        this.submitUpload.emit(this.selectedFile);
    }
}
